import ErrorPage from 'components/ErrorPage';
import LoadingSpinner from 'components/LoadingSpinner';
import MeetingStatus from 'enums/MeetingStatus';
import React from 'react';
import { useSelector } from 'react-redux';
import ClassroomStyleWrapper from './components/ClassroomStyleWrapper';
import JoinMeetingPopup from './components/JoinMeetingPopup';
import ViewContainer from './components/views/ViewContainer';

export default function Classroom() {
  const { hasJoined, meetingStatus, errorMessage } = useSelector(({ chime, classroom }) => ({
    hasJoined: chime.hasJoined,
    meetingStatus: chime.meetingStatus,
    errorMessage: classroom.actionStatus.joinMeeting?.error,
  }));

  return (
    <div>
      {meetingStatus === MeetingStatus.Loading && <LoadingSpinner />}
      {meetingStatus === MeetingStatus.Failed && <ErrorPage errorMessage={errorMessage} />}
      {meetingStatus === MeetingStatus.Succeeded && (
        <>
          {hasJoined ? (
            <ClassroomStyleWrapper>
              <ViewContainer />
            </ClassroomStyleWrapper>
          ) : (
            <JoinMeetingPopup />
          )}
        </>
      )}
    </div>
  );
}
